import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/shared/lib/supabase";
import { useDemoMode } from "@/pages/demo/DemoModeContext";

export function useEstateLastActivity(estateId: number | undefined) {
  const { isDemoMode } = useDemoMode();

  return useQuery({
    queryKey: ["estate-last-activity", estateId],
    queryFn: async (): Promise<string | null> => {
      const { data, error } = await supabase
        .from("activity_logs")
        .select("created_at")
        .eq("estate_id", estateId as number)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return data?.created_at ?? null;
    },
    enabled: !!estateId && !isDemoMode,
    staleTime: isDemoMode ? Infinity : 60 * 1000,
  });
}
